import { useState } from "react";
import { DataTable } from "../../components/organisms/DataTable";
import { PaisCard } from "./PaisCard";
import { paginacion } from "../../utils/paginacion/paginacion";

const PAISES_POR_PAGINA = 15;

export const PaisList = ({ paises = [], onRefresh }) => {
  const [paginaActual, setPaginaActual] = useState(1);
  const [busqueda, setBusqueda] = useState("");

  const paisesFiltrados = paises.filter((pais) => {
    const texto = busqueda.toLowerCase();
    return pais?.nombre?.toLowerCase().includes(texto);
  });

  const {
    objetosEnPagina: paisesEnPagina,
    paginas,
    paginaInicial,
    paginaFinal,
  } = paginacion(paginaActual, paisesFiltrados, PAISES_POR_PAGINA);

  const columnas = ["#", "Nombre", "Opciones"];

  const handleDelete = (idPais) => {
    onRefresh?.();
  };

  return (
    <section className="px-4 pb-10 max-w-6xl mx-auto">
      <div className="flex justify-between items-center my-4">
        <input
          type="text"
          placeholder="Buscar por nombre..."
          value={busqueda}
          onChange={(e) => {
            setBusqueda(e.target.value);
            setPaginaActual(1);
          }}
          className="border border-gray-300 rounded px-4 py-2 w-full max-w-md"
        />
      </div>

      <DataTable
        columnas={columnas}
        paginas={paginas}
        paginaInicial={paginaInicial}
        paginaFinal={paginaFinal}
        paginaActual={paginaActual}
        setPaginaActual={setPaginaActual}
      >
        {paisesEnPagina.length === 0 ? (
          <tr>
            <td colSpan={columnas.length} className="text-center py-8 text-gray-500">
              No hay países registrados
            </td>
          </tr>
        ) : (
          paisesEnPagina.map((pais, index) => (
            <PaisCard
              key={pais.idPais}
              pais={pais}
              index={paginaInicial + index}
              onDelete={handleDelete}
            />
          ))
        )}
      </DataTable>
    </section>
  );
};